/**
 * app/screens/UnavailableScreen.tsx
 * ----------------------------------
 * What: Fallback screen for offline/server-down states.
 * Why: Provides clear messaging and avoids rendering broken app UI.
 */
import React from 'react';
import { SafeAreaView, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useTheme } from '../../lib/ThemeContext';

interface Props {
  type: 'offline' | 'server_down';
}

export default function UnavailableScreen({ type }: Props) {
  const { theme } = useTheme();
  const title = type === 'offline' ? "You're Offline" : "It's not you, it's not even us!";
  const message = type === 'offline'
    ? "It looks like you're offline.\nPlease check your internet connection and try again."
    : "Our upstream service providers seem to be having a moment right now.\nWe're working with them to get things back up.\nPlease try again shortly.";

  return (
    <SafeAreaView style={[styles.container, { backgroundColor: theme.background }]}> 
      <Ionicons name="cloud-offline" size={64} color={theme.error} style={styles.icon} />
      <Text style={[styles.title, { color: theme.text }]}>{title}</Text>
      <Text style={[styles.message, { color: theme.secondaryText }]}>{message}</Text>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 32,
  },
  icon: {
    marginBottom: 24,
  },
  title: {
    fontSize: 22,
    fontWeight: '600',
    textAlign: 'center',
    marginBottom: 12,
  },
  message: {
    fontSize: 16,
    textAlign: 'center',
  },
}); 